/* Component Dependencies */
var heroImageTemplate = require('templates/heroImages.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'heroImages',
  template: {
    'heroImages': heroImageTemplate
  },
  events: {
    'click .view-photos, .mi-carousel img': 'openGallery'
  },
  viewPhotosInstance: null,
  bindEvents: function() {
    if (this.$el.find('.view-photos').length) {
      this.viewPhotosInstance = new Popup({
        manualHandle: true,
        selector: '.view-photos',
        sourceBlock: '.modal-content',
        url: this.$el.find('.view-photos').data('url'),
        alternateCloseMarkup: true,
        fullScreen: true,
        mainClass: 'mi-gallery mi-gallery-full',
        enableEscapeKey: true,
        cacheAjaxContent: true
      });
      this.viewPhotosInstance.register();
    } else {
      this.$el.find('img').css("cursor", "default");
    }
  },
  /**
   * This function is used to trigger the view photos button click, on click of the carousel images
   * @return {boolean} operation success or not
   */
  openGallery: function(e) {
    e.preventDefault();
    if(this.viewPhotosInstance && $(e.target).parents('.hero-image').data('propertyImagesExist')) {
      this.viewPhotosInstance.openPopup();
    }
    return true;
  }
});
